// src/hooks/useAuth.js
// Sprint 51 - Hook de autenticacion JWT.
// POST /api/auth/login + persistencia delegada a apiClient
// (que maneja storage, header Authorization y refresh automatico).
import { useCallback, useState } from 'react';
import apiClient from '../api/apiClient';

export default function useAuth() {
  const [user, setUserState]   = useState(() => apiClient.getUser());
  const [token, setTokenState] = useState(() => apiClient.getAccessToken());

  const login = useCallback(async (email, password) => {
    const data = await apiClient.post('/auth/login', { email, password });
    if (!data || !data.access_token) {
      throw new Error('Respuesta de login invalida');
    }
    apiClient.setAccessToken(data.access_token);
    if (data.refresh_token) {
      apiClient.setRefreshToken(data.refresh_token);
    }
    if (data.user) {
      apiClient.setUser(data.user);
    }
    setTokenState(data.access_token);
    setUserState(data.user || null);
    return data;
  }, []);

  const logout = useCallback(() => {
    apiClient.clearAuth();
    setTokenState(null);
    setUserState(null);
  }, []);

  return {
    user,
    token,
    isAuthenticated: Boolean(token),
    login,
    logout,
  };
}
